import { observer } from "mobx-react-lite";
import { ContextProps, Link } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags, getDataTitleTag } from "@menu/core/lib";
import { useOpenLink } from "@menu/core/hooks";

const ProfileMenu = observer((props: ContextProps) => {
  const { context } = props;
  const openLink = useOpenLink(context);

  if (!context.isLoggedIn || context.config.hideProfile) {
    return null;
  }

  const profileLinks = context.config.accountManagementMenu;

  const topNavCssName = context.config.useGraphicalMenu ? "top-nav" : "";

  const menuCssName =`profile-menu ${topNavCssName} ` + (context.displayProfileMenu ? " open" : "");

  const onSelect = (e: any, link: Link) => openLink(e, link, context);

  const getAnalytics = (link: Link) => {
    return getAnalyticTags({
      component_name: "account_popover",
      nav_item: AnalyticsType.topLevel,
      nav_text: link.title,
      target_page_url: "_self"
    });
  };

  return (
    <ul className={menuCssName}>
      {profileLinks.map((x, ix) => <li
          key={ix}
          {...getAnalytics(x)}
          {...getDataTitleTag(x.title)}
          onClick={(e) => onSelect(e, x)}>
          {x.title}
        </li>)}
    </ul>);
});

export default ProfileMenu;